// Active Ingredients Popup Desktop - JavaScript
(function() {
  document.addEventListener('DOMContentLoaded', () => {
    const closeButtonsDesktop = document.querySelectorAll('.aipop-close-button-desktop');
    const overlayDesktop = document.querySelector('.aipop-overlay-desktop');
    const popupContainerDesktop = document.querySelector('.aipop-carousel-container-desktop');
    const carouselDesktop = document.querySelector('.aipop-carousel-desktop');
    const cardsDesktop = document.querySelectorAll('.aipop-card-desktop');
    const prevButtonDesktop = document.querySelector('.aipop-prev-button-desktop');
    const nextButtonDesktop = document.querySelector('.aipop-next-button-desktop');
    const cardCounterDesktop = document.querySelector('.aipop-card-counter-desktop');
    const readMoreButtonsDesktop = document.querySelectorAll('.p-herbs-read-more-01');
  
    let aipopCurrentIndexDesktop = 0;
    const totalCardsDesktop = cardsDesktop.length;
  
    function updateAipopCarouselDesktop() {
      carouselDesktop.style.transform = `translateX(-${aipopCurrentIndexDesktop * 620}px)`;
      cardCounterDesktop.textContent = `${aipopCurrentIndexDesktop + 1} OF ${totalCardsDesktop}`;
  
      cardsDesktop.forEach((card, index) => {
        if (index === aipopCurrentIndexDesktop) {
          card.classList.add('aipop-card-active-desktop');
        } else {
          card.classList.remove('aipop-card-active-desktop');
        }
      });
    }
  
    closeButtonsDesktop.forEach(button => {
      button.addEventListener('click', () => {
        overlayDesktop.style.display = 'none';
        popupContainerDesktop.style.display = 'none';
        document.body.classList.remove('no-scroll');
      });
    });
  
    readMoreButtonsDesktop.forEach((button, index) => {
      button.addEventListener('click', () => {
        aipopCurrentIndexDesktop = index;
        updateAipopCarouselDesktop();
        overlayDesktop.style.display = 'block';
        popupContainerDesktop.style.display = 'block';
        document.body.classList.add('no-scroll');
      });
    });
  
    prevButtonDesktop.addEventListener('click', () => {
      if (aipopCurrentIndexDesktop > 0) {
        aipopCurrentIndexDesktop--;
        updateAipopCarouselDesktop();
      }
    });
  
    nextButtonDesktop.addEventListener('click', () => {
      if (aipopCurrentIndexDesktop < totalCardsDesktop - 1) {
        aipopCurrentIndexDesktop++;
        updateAipopCarouselDesktop();
      }
    });
  
    updateAipopCarouselDesktop();
  });
})();
